import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {
  StyledMissingBillsTab,
  StyledMissingBillsTabDescription,
  StyledMissingBillsTabRowIcon
} from './StyledMissingBillsTab';
import EmptyOrTable from '../../../../EmptyOrTable';
import TableFilters from '../../../InvoicesPage/tabComponents/TableFilters';
import {TransactionAddIcon} from '../../../../../icons';
import {accountingHelpers} from '../../../../../utils/helpers';

const dateColumnProps = accountingHelpers.getDateColumnProps()

const MissingBillsTab = ({
  data = [],
  empty,
  loading = false,
  onFilter,
  onRowUpdate,
  tableFiltersProps,
  tableProps,

  dispatch,
  employees,
  ...rest
}) => {
  const [t] = useTranslation(['main', 'accounting']);
  const [query, setQuery] = useState({ search: '' });

  const handleOnFilter = (filterParams) => {
    setQuery({...query, ...filterParams});
    onFilter?.(filterParams);
  }

  const getVendor = (vendor, record) => record?.expense?.vendor || '';

  const columns = [
    {
      ...dateColumnProps,
      dataIndex: 'transaction_date',
      render: accountingHelpers.getEntryTransactionDate,
      title: t('date')
    },
    {
      align: 'right',
      dataIndex: 'amount',
      render: (_, record) => accountingHelpers.getEntryAmount(record),
      title: t('amount'),
    },
    {
      dataIndex: 'card_public_token',
      title: `${t('card')} ID`,
      render: accountingHelpers.getEntryCardId
    },
    {
      dataIndex: 'vendor',
      title: t('vendor'),
      render: getVendor
    },
    {
      dataIndex: 'card_owner_user_id',
      title: t('user'),
      render: (value) => accountingHelpers.getOwnerDetails({ value, employees })
    },
    {
      align: 'right',
      dataIndex: 'match',
      render: () => (
        <StyledMissingBillsTabRowIcon>
          <TransactionAddIcon />
        </StyledMissingBillsTabRowIcon>
      )
    }
  ];

  return (
    <StyledMissingBillsTab
      {...rest}
      size='large'
      direction='vertical'
    >
      <TableFilters
        {...tableFiltersProps}
        onFilter={handleOnFilter}
        filterFields={['search']}
      />
      <StyledMissingBillsTabDescription>
        {t('accounting:missingBillsTabDescription')}
      </StyledMissingBillsTabDescription>
      <EmptyOrTable
        data={data}
        empty={empty}
        loading={loading}
        query={query}
        columns={columns}
        tableProps={tableProps}
      />
    </StyledMissingBillsTab>
  );
}

MissingBillsTab.propTypes = {
  columns: PropTypes.array,
  data: PropTypes.array,
  empty: PropTypes.any,
  loading: PropTypes.bool,
  onFilter: PropTypes.func,
  tableFiltersProps: PropTypes.any,
  tableProps: PropTypes.object
}

const mapStateToProps = ({
  company: { employees },
}) => ({
  employees,
});

export default connect(mapStateToProps, null)(MissingBillsTab);
